import { StoreState } from '../store-interfaces';

export const selectTopDialogues = (state: StoreState) =>
  state.botAnalytics.topDialogues;

export const selectContactsAmountAnalytics = (state: StoreState) =>
  state.botAnalytics.contactsAmountAnalytics;

export const selectUnansweredQuestions = (state: StoreState) =>
  state.botAnalytics.unansweredQuestions;

export const selectContactsByPlatform = (state: StoreState) =>
  state.botAnalytics.contactsByPlatform;

export const selectContactsBySource = (state: StoreState) =>
  state.botAnalytics.contactsBySource;

export const selectQAKeyword = (state: StoreState) =>
  state.botAnalytics.qaKeywords;

export const selectContactsByPlatformAggregated = (state: StoreState) =>
  state.botAnalytics.contactsByPlatformAggregated;

export const selectEmailAnalytics = (state: StoreState) =>
  state.botAnalytics.emailAnalyticsByTab;

export const selectXRayAnalytics = (state: StoreState) =>
  state.botAnalytics.xRayAnalytics;

export const selectContactsSourcesAnalytics = (state: StoreState) =>
  state.botAnalytics.contactsSources;

export const selectDemographicAnalytics = (state: StoreState) =>
  state.botAnalytics.demographicAnalytics;
